export { default } from './FieldList';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/FieldList/index.js